module.exports = __webpack_public_path__ + "static/media/about-vpassport-en.fc3dc0fc.mp4";